import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { Currency } from 'projects/common/model/landingModel';
import { OfferCardData, OfferCardDataPrice } from '../offer-card-data.model';

@Component({
  selector: 'pricebox-with-child',
  template: `
    <div class="pricebox-with-child">
      <ng-container *ngFor="let priceData of [price, child_price]">
        <div *ngIf="priceData" class="pricebox-with-child-item">
          <div class="pricebox-with-child-description eva-3-caption -eva-3-mb-xsm">
            {{priceData.message}}
          </div>
          <div class="pricebox-with-child-price eva-3-h4 -eva-3-mb-xsm">
            <div class="pricebox-with-child-current">
              <span class="pricebox-with-child-currency -eva-3-mr-xsm">{{currency.symbol}}</span>
              <span class="pricebox-with-child-amount">{{priceData.total_amount}}</span>
            </div>
          </div>
          <div class="pricebox-with-child-message eva-3-caption">
            {{priceData.per_day}}
          </div>
        </div>
      </ng-container>

      <div *ngIf="price.tax_message" class="pricebox-with-child-tax eva-3-caption -eva-3-mt-sm">
        {{price.tax_message}}
      </div>
    </div>
  `,
  styleUrls: ['./pricebox-with-child.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PriceboxWithChildComponent implements OnInit, OnChanges{
  @Input() data: OfferCardData;
  @Input() currency: Currency;
  @Input() locale: string;

  price: OfferCardDataPrice;
  child_price: OfferCardDataPrice;

  ngOnInit(): void {
    this.initPrice();
  }

  ngOnChanges(): void {
    this.initPrice();
  }

  private initPrice(): void {
    this.child_price = this.data.price_child[this.currency.code];
    this.price = this.data.price[this.currency.code];
  }
}
